/**
 * Les chapitres du voyage, dans l'ordre de la page. Chacun a son trou noir
 * (le décor) et sa carte d'identité (le contenu) : ce module est leur langage commun.
 */
export const CHAPTER_KEYS = [
  'origin',
  'studio',
  'expertises',
  'applications',
  'method',
  'brief',
  'horizon',
] as const;

export type ChapterKey = (typeof CHAPTER_KEYS)[number];

export const isChapterKey = (value: string | undefined): value is ChapterKey =>
  CHAPTER_KEYS.some((key) => key === value);

export type BlackHoleSide = 'left' | 'right' | 'center';

/**
 * Le côté de l'écran où se tient le trou noir de chaque chapitre. Le texte
 * s'installe en face, et la page zigzague d'un côté à l'autre.
 */
export const BLACK_HOLE_SIDE: Readonly<Record<ChapterKey, BlackHoleSide>> = {
  origin: 'right',
  studio: 'left',
  expertises: 'right',
  applications: 'left',
  method: 'right',
  brief: 'left',
  horizon: 'center',
};

/** -1 à gauche, 1 à droite (le centre compte comme la droite). */
export const sideSign = (side: BlackHoleSide): 1 | -1 => (side === 'left' ? -1 : 1);
